<div id="glossary-loading" *ngIf="loading" class="m-3">
    <i class="fas fa-spinner fa-spin"></i>
    <span>Cargando...</span>
</div>

<div id="glossary-error" *ngIf="!loading && error" class="m-3 text-danger">
    <i class="fas fa-times"></i>
    <span>Error</span>
</div>

<div id="glossary" *ngIf="!loading && !error" class="m-3">

    <h1 id="glossary-title" class="mb-3" *ngIf="title">
        {{ title }}
    </h1>

    <div id="glossary-words-buttons" class="mb-3">
        <button class="btn btn-primary me-3" (click)="toggleImport()">
            <div *ngIf="!import">
                <i class="fa fa-upload"></i>
                <span>Importar</span>
            </div>
            <div *ngIf="import">
                <i class="fa fa-eye"></i>
                <span>Ver palabras</span>
            </div>
        </button>

        <button class="btn btn-primary me-3" *ngIf="!import && wordsNum > 0" (click)="glossaryExport()">
            <i class="fa fa-download"></i>
            <i class="fa fa-file-excel"></i>
            <span>Exportar a CSV</span>
        </button>
    </div>

    <div id="glossary-words-import" class="mb-3" *ngIf="import">
        <div id="glossary-words-import-options" class="my-3">
            <label class="d-block mb-3">
                <input type="radio" name="import" [(ngModel)]="importType" value="unit" (ngModelChange)="toggleImportType()">
                <span class="ms-2">De otra unidad del mismo curso</span>
            </label>

            <label class="d-block mb-3">
                <input type="radio" name="import" [(ngModel)]="importType" value="courseUnit" (ngModelChange)="toggleImportType()">
                <span class="ms-2">De otra unidad de otro curso</span>
            </label>

            <label class="d-block mb-3">
                <input type="radio" name="import" [(ngModel)]="importType" value="csv" (ngModelChange)="toggleImportType()">
                <span class="ms-2">De un archivo CSV</span>
            </label>
        </div>

        <div id="glossary-words-import-unit">
            <div class="mb-3" *ngIf="importType == 'courseUnit' && importCategories.length > 0">
                <p class="fw-bold">Categoría:</p>
                <select class="form-control" [(ngModel)]="importCategory" (ngModelChange)="getCategoryCourses(importCategory)">
                    <option disabled [value]="-1">Seleccione una categoría...</option>
                    <option *ngFor="let icat of importCategories" [value]="icat.id">
                        {{ icat.name }}
                    </option>
                </select>
            </div>

            <div class="mb-3" *ngIf="importType == 'courseUnit' && importCourses.length > 0">
                <p class="fw-bold">Curso:</p>
                <select class="form-control" [(ngModel)]="importCourse" (ngModelChange)="getCourseUnits(importCourse)">
                    <option disabled [value]="-1">Seleccione un curso...</option>
                    <option *ngFor="let icrs of importCourses" [value]="icrs.id">
                        {{ icrs.name }}
                    </option>
                </select>
            </div>

            <div class="mb-3" *ngIf="(importType == 'unit' || importType == 'courseUnit') && importUnits.length > 0">
                <p class="fw-bold">Unidad:</p>
                <select class="form-control" [(ngModel)]="importUnit" (ngModelChange)="selectUnitGlossary()">
                    <option disabled [value]="-1">Seleccione una unidad...</option>
                    <option *ngFor="let iu of importUnits" [value]="iu.id" [class.text-danger]="iu.glossary == false">
                        {{ iu.name }}
                    </option>
                </select>
            </div>
        </div>

        <div id="glossary-words-import-csv" *ngIf="importType == 'csv'" class="my-3">
            <input type="file" accept="text/csv" (change)="csvUpload($event)">
        </div>

        <div id="glossary-words-import-num" *ngIf="importWordsNum > 0" class="my-3">
            <p class="fw-bold">Total de palabras a importar: {{ importWordsNum }}</p>
        </div>

        <div id="glossary-words-import-num-0" *ngIf="wordsNotFound" class="text-danger my-3">
            <p class="fw-bold">
                <i class="fa fa-times"></i>
                <span>No se han encontrado palabras para importar. Modifica el archivo o intenta con otro archivo.</span>
            </p>
        </div>

        <div id="glossary-words-import-reset" *ngIf="importWordsNum > 0" class="my-3">
            <label>
                <input type="checkbox" [(ngModel)]="importReset">
                <span class="ms-2">¿Borrar entradas existentes?</span>
            </label>
        </div>

        <div id="glossary-words-import-status" class="mb-3" *ngIf="importing || importSuccess || importError">
            <div id="glossary-words-importing" *ngIf="importing">
                <i class="fa fa-spinner fa-spin"></i>
                <span>Importando palabras...</span>
            </div>
            <div id="glossary-words-import-success" class="text-success" *ngIf="importSuccess">
                <i class="fa fa-check"></i>
                <span>Las palabras se han importado correctamente.</span>
            </div>
            <div id="glossary-words-import-error" class="text-danger" *ngIf="importError">
                <i class="fa fa-times"></i>
                <span>Ha habido un error al importar palabras.</span>
            </div>
        </div>

        <button class="btn btn-primary" *ngIf="importWordsNum > 0" (click)="glossaryImport()" [attr.disabled]="importing ? 'disabled' : null">
            <i class="fa fa-upload"></i>
            <span>Importar palabras</span>
        </button>
    </div>
    
    <div id="glossary-words-container" *ngIf="!import">
        <div id="glossary-words-empty" *ngIf="wordsNum == 0">
            <p>No hay palabras.</p>
        </div>
    
        <div id="glossary-words-num" *ngIf="wordsNum > 0">
            <p class="fw-bold">Total de palabras: {{ wordsNum }}</p>
        </div>
        
        <table id="glossary-words-table" *ngIf="wordsNum > 0">
            <thead>
                <tr class="fw-bold text-center">
                    <th>Término</th>
                    <th>Definición</th>
                    <th width="100">Acciones</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let word of words; let w = index;">
                    <td>
                        <span title="Haz clic para editar la palabra" (click)="showEdit($event)">
                            {{ word.word }}
                        </span>
                        
                        <input type="text" class="d-none" title="Presiona Enter para guardar los cambios, Esc para cancelar" (keydown.enter)="editWord($event, word.id)" (keydown.esc)="hideEdit($event)" value="{{ word.word }}">
                    </td>
                    <td>
                        <span title="Haz clic para editar la definición" (click)="showEdit($event)">
                            {{ word.definition }}
                        </span>
    
                        <textarea type="text" class="d-none" cols="50" rows="5" title="Presiona Enter para guardar los cambios, Esc para cancelar" (keydown.enter)="editWordDefinition($event, word.id)" (keydown.esc)="hideEdit($event)" value="{{ word.definition }}"></textarea>
                    </td>
                    <td>
                        <a href="#" class="me-2" title="Mover hacia arriba" (click)="moveWord(w, 'up')" *ngIf="wordsNum > 1">
                            <i class="fas fa-arrow-up"></i>
                        </a>
                        <a href="#" class="me-2" title="Mover hacia abajo" (click)="moveWord(w, 'down')" *ngIf="wordsNum > 1">
                            <i class="fas fa-arrow-down"></i>
                        </a>
                        <a href="#" class="me-2" title="Eliminar" (click)="deleteWord(w)">
                            <i class="fas fa-times text-danger"></i>
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
        
        <hr>
        
        <button class="btn btn-success mt-3" (click)="addWord()">
            <i class="fas fa-plus"></i>
            <span>Añadir palabra</span>
        </button>
    </div>

</div>